import { commandCenterUnderwritingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_CONDITION_HEATMAP_ACTION_TYPE = createNamedActions(
  'commandCenterConditionHeatmap',
  {
    SET_CONDITION_HEATMAP: 'SET_CONDITION_HEATMAP',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterConditionHeatmapAction = catchAsyncActionError(
  () => async dispatch => {
    try {
      const data = await fetchSafe(() =>
        commandCenterUnderwritingApi.getConditionHeatmap({
          includeByFile: true,
          config: SKIP_FORBIDDEN_CONFIG,
        }),
      );

      dispatch({
        type: COMMAND_CENTER_CONDITION_HEATMAP_ACTION_TYPE.SET_CONDITION_HEATMAP,
        payload: data,
      });
    } finally {
      // In a `finally` so the slice is marked loaded even when a swallowed 403/404
      // degrades to null — otherwise the zone skeleton never clears (DEV-4173).
      dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.CONDITION_HEATMAP));
    }
  },
);
